<app-navbar></app-navbar>

<!-- Mostrar loading mientras se cargan los datos -->
@if (!hosting) {
<div class="loading-container">
  <div class="loading-spinner">Cargando detalles del alojamiento...</div>
</div>
} @else {
<app-galery [hosting]="hosting"></app-galery>

<div class="main-container">
  <div class="detail-container">
    <!-- Sección de Datos Básicos -->
    <section class="detail-section">
      <h2>
        <strong>{{ hosting.name }}</strong>
      </h2>
      <!-- Sección de ubicación del alojamiento -->
      @if (hosting?.location) {
      <section class="detail-section" style="margin-bottom: 16px;">
        <h2>Ubicación</h2>
        <div>
          <p><strong>Ciudad:</strong> {{ hosting.location.city }}</p>
          <p><strong>País:</strong> {{ hosting.location.country }}</p>
          <p><strong>Dirección:</strong> {{ hosting.location.adress }}</p>
          <p><strong>Latitud:</strong> {{ hosting.location.latitude }}</p>
          <p><strong>Longitud:</strong> {{ hosting.location.longitude }}</p>
        </div>
      </section>
      }
    </section>
    <!-- Sección de Datos de Servicios adicionales -->
    <section class="detail-section">
      <div class="description">
        <h2>Descripción</h2>
        <p>{{hosting.description}}</p>
      </div>
      <div class="total-services">
        <div class="additional-services">
          <h2>Servicios adicionales</h2>
          <div>
            @for (service of additionalServices; track service.id) {
            <label>
              <input type="checkbox" [checked]="service.selected" (change)="toggleService(service)" />
              {{ service.service }} - ${{ service.cost }}
              <br>
            </label>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- Sección de Datos de Reglas -->
    <section class="detail-section">
      <h2>Reglas</h2>
      <div>
        <p><strong>Título:</strong> {{ hosting.rule.title }}</p>
        <p><strong>Categoría:</strong> {{ hosting.rule.category }}</p>
        <p><strong>Descripción:</strong> {{ hosting.rule.description }}</p>
        <p><strong>Penalización:</strong> {{ hosting.rule.penalty }}</p>
        <p><strong>Estado:</strong> {{ hosting.rule.status }}</p>
      </div>
    </section>
    <section class="detail-section">
      <h2>Reseñas</h2>
      <div class="reviews">
        @for (review of visibleReviews; track $index) {
        <div class="review">
          <div class="stars">
            @for (star of [1,2,3,4,5]; track $index) {
            <span class="star">{{ star <= review.rating ? '★' : '☆' }}</span>
                }
                <span></span>
          </div>
          <div class="review-content">
            <p class="review-comment">{{ review.comment }}</p>
          </div>
          <div class="review-meta">
            <span>Por: Usuario {{ review.customer_id | slice:0:6 }}</span>
            <span>{{ review.created_at | date:'mediumDate' }}</span>
          </div>
        </div>
        }
      </div>
      @if (reviews.length > visibleReviewsLimit && !showAllReviews) {
      <button class="show-more-btn" (click)="toggleReviewModal()">
        Ver más reseñas ({{reviews.length - visibleReviewsLimit}})
      </button>
      }
    </section>

    <!-- Modal de Reviews -->
    @if (modalOpen) {
    <div class="reviews-modal-overlay" (click)="toggleReviewModal()">
      <div class="reviews-modal-content" (click)="$event.stopPropagation()">
        <button class="close-modal-btn" (click)="toggleReviewModal()">
          &times;
        </button>
        <h2>Todas las reseñas</h2>
        <div class="modal-reviews-container">
          @for (review of reviews; track $index) {
          <div class="review">
            <div class="stars">
              @for (star of [1,2,3,4,5]; track $index) {
              <span class="star">{{ star <= review.rating ? '★' : '☆' }}</span>
                  }
                  <span></span>
            </div>
            <div class="review-content">
              <p class="review-comment">{{ review.comment }}</p>
            </div>
            <div class="review-meta">
              <span>Por: Usuario {{ review.customer_id | slice:0:6 }}</span>
              <span>{{ review.created_at | date:'mediumDate' }}</span>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <section class="detail-section">
      <h2>Datos del Anfitrión</h2>
      <div>
        <p><strong>Nombre:</strong> {{ hosting.amphitryon.name }} {{ hosting.amphitryon.lastname }}</p>
        <p><strong>Email:</strong> {{ hosting.amphitryon.email }}</p>
      </div>
    </section>
  </div>


  <!-- Componente de Carrito -->
  <section class="cart">
    <h2><strong>Resumen de tu reserva</strong></h2>

    <!-- Contenedor azul estilo Booking.com -->
    <div class="booking-container-vertical">
      <!-- Formulario de reserva estilo Booking.com vertical -->
      <div class="booking-form-vertical">

        <!-- Campo de fechas -->
        <div class="form-field dates-field-vertical">
          <span class="field-label">Fechas de estancia</span>
          <div class="dates-content-vertical">
            <div class="date-input-group-vertical">
              <div class="date-input-vertical">
                <label class="date-label" for="checkInDate">Entrada</label>
                <input id="checkInDate" type="date" [(ngModel)]="checkInDateStr" (ngModelChange)="onDateChange()"
                  class="field-input date-field-vertical">
              </div>
              <div class="date-input-vertical">
                <label class="date-label" for="checkOutDate">Salida</label>
                <input id="checkOutDate" type="date" [(ngModel)]="checkOutDateStr" (ngModelChange)="onDateChange()"
                  class="field-input date-field-vertical">
              </div>
            </div>
          </div>
        </div>

        <!-- Campo de huéspedes -->
        <div class="form-field guests-field-vertical">
          <span class="field-label">Huéspedes</span>
          <button type="button" class="guests-summary-vertical" (click)="toggleGuestsDropdown()"
            [attr.aria-expanded]="showGuestsDropdown">
            <span>{{getGuestsSummary()}}</span>
            <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>
          </button>

          <!-- Dropdown de huéspedes -->
          <div class="guests-dropdown-vertical" [class.show]="showGuestsDropdown">
            <div class="guest-row-vertical">
              <div class="guest-info-vertical">
                <span class="guest-type">Adultos</span>
                <span class="guest-age">Edad: 13 años o más</span>
              </div>
              <div class="guest-controls-vertical">
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('adults', -1)"
                  [disabled]="adults <= 1">−</button>
                <span class="guest-count-vertical">{{adults}}</span>
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('adults', 1)">+</button>
              </div>
            </div>

            <div class="guest-row-vertical">
              <div class="guest-info-vertical">
                <span class="guest-type">Niños</span>
                <span class="guest-age">De 2 a 12 años</span>
              </div>
              <div class="guest-controls-vertical">
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('children', -1)"
                  [disabled]="childrenOver2 <= 0">−</button>
                <span class="guest-count-vertical">{{childrenOver2}}</span>
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('children', 1)">+</button>
              </div>
            </div>

            <div class="guest-row-vertical">
              <div class="guest-info-vertical">
                <span class="guest-type">Bebés</span>
                <span class="guest-age">Menos de 2 años</span>
              </div>
              <div class="guest-controls-vertical">
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('babies', -1)"
                  [disabled]="babiesUnder2 <= 0">−</button>
                <span class="guest-count-vertical">{{babiesUnder2}}</span>
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('babies', 1)">+</button>
              </div>
            </div>

            <div class="guest-row-vertical">
              <div class="guest-info-vertical">
                <span class="guest-type">Mascotas</span>
                <span class="guest-age">¿Traes un animal de servicio?</span>
              </div>
              <div class="guest-controls-vertical">
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('pets', -1)"
                  [disabled]="pets <= 0">−</button>
                <span class="guest-count-vertical">{{pets}}</span>
                <button type="button" class="guest-btn-vertical" (click)="updateGuests('pets', 1)">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mostrar el número de noches -->
    @if (numberOfNights > 0) {
    <div class="nights-info">
      <p><strong>Número de noches: {{ numberOfNights }}</strong></p>
    </div>
    }

    <!-- Mostrar el subtotal precio de la habitación por X noches (visible solo en pantallas medianas y grandes) -->
    @if (!isSmallScreen) {
    <div class="Subtotal">
      <p>Precio por noche x {{numberOfNights}} noches: {{hosting.room?.price_per_night | currency:'COP
        ':'symbol':'1.2-2'}} x {{numberOfNights}} </p>
      <h3><strong>Subtotal habitación:</strong> {{roomSubtotal | currency:'COP ':'symbol':'1.2-2' }} </h3>
    </div>
    <div class="Subtotal">
      <p><strong>Servicios adicionales:</strong></p>
      @for (service of selectedServices; track service.id) {
      <p>{{ service.service }} - {{ service.cost | currency:'COP ':'symbol':'1.2-2' }}</p>
      }
      <p><strong>Subtotal servicios adicionales:</strong> {{ servicesSubtotal | currency:'COP ':'symbol':'1.2-2' }}</p>
    </div>
    <p><strong>Total:</strong> {{ total | currency:'COP ':'symbol':'1.2-2' }}</p>
    }


    <!-- Mostrar el precio básico por noche y el botón de reserva (visible en todas las pantallas) -->
    @if (isSmallScreen) {
    <div class="Subtotal-s">
      <p><strong>Precio por noche:</strong> {{ total | currency:'COP ':'symbol':'1.2-2' }}</p>
    </div>
    }
    <div><button class="order-btn" (click)="onReserveClick()">Reservar</button></div>

  </section>
</div>
}

<app-footer></app-footer>
